module.exports = __webpack_public_path__ + "img/MA-HMI-5.1ed9cff5.png";